export class VoucherOrder {

  constructor(category, product, maskedMsisdn, vendorName, eligibility, isAdvanceEligible, paymentType, termDuration) {
    this.category = category;
    this.product = product;
    this.maskedMsisdn = maskedMsisdn;
    this.vendorName = vendorName;
    this.eligibility = eligibility;
    this.isAdvanceEligible = isAdvanceEligible;
    this.paymentType = paymentType;
    this.termDuration = termDuration;
  }
}